// extracted by mini-css-extract-plugin
module.exports = {"notice":"About_notice__1Ap_S","title":"About_title__1fYye","content":"About_content__31oau"};